import {z} from 'zod';
import {nodeSchema} from './node';
import {connectionSchema} from './connection';

/**
 * Workflow metadata for tracking origin and lifecycle.
 */
export const workflowMetadataSchema = z.object({
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  source: z.string().min(1),
  sourceVersion: z.string(),
  tags: z.array(z.string()).default([]),
});

export type WorkflowMetadata = z.infer<typeof workflowMetadataSchema>;

export const WORKFLOW_SCHEMA_VERSION = '1.0.0' as const;

export const workflowSchema = z.object({
  id: z.string().startsWith('wf_'),
  version: z.literal(WORKFLOW_SCHEMA_VERSION),
  name: z.string().min(1).max(200),
  description: z.string().optional(),
  metadata: workflowMetadataSchema,
  nodes: z.array(nodeSchema),
  connections: z.array(connectionSchema),
  rawSource: z.unknown().optional(),
});

export type Workflow = z.infer<typeof workflowSchema>;
